import { Component, deserializeComponent } from './Component';

export interface SceneData {
  version: number;
  components: Record<string, unknown>[];
}

export class Scene {
  private components: Map<number, Component> = new Map();

  add(component: Component): void {
    this.components.set(component.id, component);
  }

  remove(id: number): void {
    this.components.delete(id);
  }

  get(id: number): Component | undefined {
    return this.components.get(id);
  }

  getAll(): Component[] {
    return Array.from(this.components.values());
  }

  clear(): void {
    this.components.clear();
  }

  get count(): number {
    return this.components.size;
  }

  toJSON(): SceneData {
    return {
      version: 1,
      components: this.getAll().map(c => c.serialize()),
    };
  }

  static fromJSON(data: SceneData): Scene {
    const scene = new Scene();
    for (const compData of data.components) {
      scene.add(deserializeComponent(compData));
    }
    return scene;
  }
}
